import { ArrowLeftIcon, Button } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import { useResetSearch } from './useResetSearch';

function GoBackButton() {
  const resetSearch = useResetSearch();

  return (
    <Button
      className="justify-start"
      startContent={<ArrowLeftIcon color="white" size="md" />}
      size="sm"
      data-intercom-target="discovery-portal-go-back-button"
      onClick={resetSearch}
    >
      <T kind="Go Back" />
    </Button>
  );
}

export default observer(GoBackButton);
